import React from 'react';
import { Heart, Sparkles, Award } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

const About = () => {
  const { t } = useLang();

  return (
    <div className="min-h-screen bg-[#faf6ec]">
      <section className="pt-28 pb-12 bg-[#04140e] text-[#f5e9ce] text-center border-b border-[#c5a059]/15">
        <div className="max-w-4xl mx-auto px-6">
          <div className="inline-flex items-center space-x-3 mb-4">
            <span className="h-px w-12 bg-[#c5a059]"></span>
            <span className="text-[#c5a059] text-xs tracking-[0.3em]">— OUR STORY</span>
            <span className="h-px w-12 bg-[#c5a059]"></span>
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold mb-4 text-[#f5e9ce]">{t.about.title}</h1>
          <p className="text-base sm:text-lg text-[#f5e9ce]/80 leading-relaxed max-w-3xl mx-auto">
            {t.about.welcome}
          </p>
        </div>
      </section>

      <section className="py-10 md:py-12 bg-[#faf6ec]">
        <div className="max-w-4xl mx-auto px-6 space-y-6">
          <div className="bg-white border border-[#c5a059]/30 rounded-sm p-8 md:p-12 shadow-lg">
            <h2 className="text-3xl font-serif font-bold text-[#0d3b25] mb-6 leading-tight">
              {t.about.nameMeaning}
            </h2>
            <p className="text-[#0d3b25]/80 leading-relaxed mb-4">{t.about.nameStory}</p>
            <p className="text-[#0d3b25]/80 leading-relaxed">{t.about.familyStory}</p>
          </div>

          <div className="bg-[#04140e] border border-[#c5a059]/40 text-white rounded-sm p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-4 right-4 text-[#c5a059]/20">
              <Heart className="w-24 h-24" />
            </div>
            <div className="relative">
              <h2 className="text-3xl font-serif font-bold text-[#c5a059] mb-6">{t.about.wordFromNidhi}</h2>
              <p className="leading-relaxed mb-4 text-white/85">{t.about.babyStory}</p>
              <p className="leading-relaxed text-white/85">{t.about.thanks}</p>
              <p className="mt-6 font-serif italic text-[#c5a059]">— Nidhi</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-[#faf6ec] border-t border-[#c5a059]/15">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-serif font-bold text-[#0d3b25] text-center mb-12">
            {t.about.values}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: Award, label: 'Quality' },
              { icon: Heart, label: 'Passion' },
              { icon: Sparkles, label: 'Care' },
            ].map((v, i) => (
              <div key={i} className="text-center p-6 bg-white border border-[#c5a059]/30 rounded-sm">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#c5a059] text-[#04140e] mb-4">
                  <v.icon className="w-7 h-7" />
                </div>
                <h3 className="font-serif font-semibold text-[#0d3b25] text-xl mb-2">{v.label}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
